import React from "react";
import PropTypes from "prop-types";
import styles from "./WorkItem.css";

const WorkItem = ({ history }) => {
  const { responsibilities, title, employer, timeline } = history;

  const descriptionItems = responsibilities.map(item => <li>{item}</li>);

  return (
    <div className={[styles.WorkItem, styles.clearfix].join(" ")}>
      <div className={[styles.JobHeading, styles.clearfix].join(" ")}>
        <span className={styles.JobTitle}>
          <p>{title}</p>
          <p className={styles.CompanyTitle}>{employer}</p>
        </span>
        <span className={styles.Timeline}>
          <p>{timeline}</p>
        </span>
      </div>
      <ul className={styles.Description}>{descriptionItems}</ul>
    </div>
  );
};

WorkItem.propTypes = {
  history: PropTypes.shape({
    title: PropTypes.string.isRequired,
    employer: PropTypes.string.isRequired,
    timeline: PropTypes.string.isRequired,
    responsibilities: PropTypes.array.isRequired
  }).isRequired
};

export default WorkItem;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/WorkHistory/WorkItem/WorkItem.js